import { TaskParams } from '~/components/task-forms/BaseTaskForm'
import { TaskSubmitJSONPayload } from '~/services/taskService'
import { deferred } from './async'
import { AppEvents, globalEventEmitter } from './shared'

interface PromiseMethods<T> {
  resolve?: (value: T) => void
  reject?: (reason?: unknown) => void
}

export async function createTask(task: TaskParams): Promise<boolean> {
  const promise = deferred()
  task.resolve = promise.resolve.bind(promise)
  globalEventEmitter.emit(AppEvents.CreateTask, task)
  return promise as Promise<boolean>
}

// NEW: Simplified task creation with JSON payload
export interface SimplifiedTaskParams extends PromiseMethods<boolean> {
  request: TaskSubmitJSONPayload['request']
  uuid?: string // Optional conversation UUID for editing tasks
}

export async function createTaskJSON(taskParams: SimplifiedTaskParams): Promise<boolean> {
  const promise = deferred()
  taskParams.resolve = promise.resolve.bind(promise)
  globalEventEmitter.emit(AppEvents.CreateTaskJSON, taskParams)
  return promise as Promise<boolean>
}

interface OpenDocCommentPopoverCallbackEvent {
  action: 'cancel' | 'submit'
}

export interface OpenDocCommentPopoverEvent
  extends PromiseMethods<OpenDocCommentPopoverCallbackEvent> {
  clientX: number
  clientY: number
  startLine: number
  endLine: number
}

export async function openDocReviewPopover(event: OpenDocCommentPopoverEvent) {
  const promise = deferred()
  event.resolve = promise.resolve.bind(promise)
  globalEventEmitter.emit(AppEvents.OpenDocCommentPopover, {
    clientX: event.clientX,
    clientY: event.clientY,
    startLine: event.startLine,
    endLine: event.endLine
  })
  globalEventEmitter.on(
    AppEvents.OpenDocCommentPopoverCallback,
    (event: OpenDocCommentPopoverCallbackEvent) => {
      promise.resolve(event)
    }
  )
  return promise as Promise<OpenDocCommentPopoverCallbackEvent>
}
